module.exports = __webpack_public_path__ + "img/ajax-cape-town.d0323779.png";